// extracted by mini-css-extract-plugin
export default {"CONFIG":"Config_CONFIG__lmabc"};